import { render, staticRenderFns } from "./ManagerCampEditorContacts.vue?vue&type=template&id=a837962c&lang=pug&"
import script from "./ManagerCampEditorContacts.vue?vue&type=script&lang=js&"
export * from "./ManagerCampEditorContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports